/* @generated from adl module kachemedia.specsheet.qms */

import * as ADL from './../../runtime/adl';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as kachemedia_specsheet_db from './db';
import * as sys_types from './../../sys/types';

/**
 * Data on QMS campaigns, bookings and panels.  Based on from response array entry for https://qms-api-au.orbtechnologies.com.au/api/audit/booking
 */
export interface QmsCampaignBooking {
  panelNumber: string;
  panelName: string;
  bookingCode: string;
  campaignCode: string;
  campaignName: string;
  bookingStartDate: string;
  bookingEndDate: string;
  client: string;
  agency: string;
  bookingType: string;
  auditor: string;
  salesRep: string;
  slotsBooked: string;
  digital: number;
  extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef;
}

export function makeQmsCampaignBooking(
  input: {
    panelNumber: string,
    panelName: string,
    bookingCode: string,
    campaignCode: string,
    campaignName: string,
    bookingStartDate: string,
    bookingEndDate: string,
    client: string,
    agency: string,
    bookingType: string,
    auditor: string,
    salesRep: string,
    slotsBooked: string,
    digital: number,
    extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef,
  }
): QmsCampaignBooking {
  return {
    panelNumber: input.panelNumber,
    panelName: input.panelName,
    bookingCode: input.bookingCode,
    campaignCode: input.campaignCode,
    campaignName: input.campaignName,
    bookingStartDate: input.bookingStartDate,
    bookingEndDate: input.bookingEndDate,
    client: input.client,
    agency: input.agency,
    bookingType: input.bookingType,
    auditor: input.auditor,
    salesRep: input.salesRep,
    slotsBooked: input.slotsBooked,
    digital: input.digital,
    extCampaignRef: input.extCampaignRef,
  };
}

const QmsCampaignBooking_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Data on QMS campaigns, bookings and panels.  Based on from response array entry for https://qms-api-au.orbtechnologies.com.au/api/audit/booking\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"panelNumber","default":{"kind":"nothing"},"name":"panelNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelName","default":{"kind":"nothing"},"name":"panelName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingCode","default":{"kind":"nothing"},"name":"bookingCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"campaignCode","default":{"kind":"nothing"},"name":"campaignCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"campaignName","default":{"kind":"nothing"},"name":"campaignName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingStartDate","default":{"kind":"nothing"},"name":"bookingStartDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingEndDate","default":{"kind":"nothing"},"name":"bookingEndDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"client","default":{"kind":"nothing"},"name":"client","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"agency","default":{"kind":"nothing"},"name":"agency","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingType","default":{"kind":"nothing"},"name":"bookingType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"auditor","default":{"kind":"nothing"},"name":"auditor","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"salesRep","default":{"kind":"nothing"},"name":"salesRep","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"slotsBooked","default":{"kind":"nothing"},"name":"slotsBooked","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"digital","default":{"kind":"nothing"},"name":"digital","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"extCampaignRef","default":{"kind":"nothing"},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}}]}},"name":"QmsCampaignBooking","version":{"kind":"nothing"}}};

export const snQmsCampaignBooking: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsCampaignBooking"};

export function texprQmsCampaignBooking(): ADL.ATypeExpr<QmsCampaignBooking> {
  return {value : {typeRef : {kind: "reference", value : snQmsCampaignBooking}, parameters : []}};
}

/**
 * Data on Qms Static panels (ie PrintOOH media).  Based on the emailed CSV for static media types.
 */
export interface QmsStaticPanel {
  optionDetails: string;
  clientName: string;
  quantity: number;
  size: string;
  panelNumber: string;
  panelAddress: string;
  state: string;
  fixtureType: string;
  illuminationType: string;
  visualWidth: number;
  visualHeight: number;
  bleedWidth: number;
  bleedHeight: number;
  bleedTop: number;
  bleedBottom: number;
  bleedLeft: number;
  bleedRight: number;
  physicalWidth: number;
  physicalHeight: number;
  panelCensorships: string;
  panelProhibitions: string;
  installCompanyName: string;
  panelDirection: string;
  dimensions: string;
  illuminated: string;
  startDate: string;
  productionComments: string;
  productionSpecs1: string;
  /**
   * Mapping to TSS Placement table
   */
  tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>;
}

export function makeQmsStaticPanel(
  input: {
    optionDetails: string,
    clientName: string,
    quantity: number,
    size: string,
    panelNumber: string,
    panelAddress: string,
    state: string,
    fixtureType: string,
    illuminationType: string,
    visualWidth: number,
    visualHeight: number,
    bleedWidth: number,
    bleedHeight: number,
    bleedTop: number,
    bleedBottom: number,
    bleedLeft: number,
    bleedRight: number,
    physicalWidth: number,
    physicalHeight: number,
    panelCensorships: string,
    panelProhibitions: string,
    installCompanyName: string,
    panelDirection: string,
    dimensions: string,
    illuminated: string,
    startDate: string,
    productionComments: string,
    productionSpecs1: string,
    tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>,
  }
): QmsStaticPanel {
  return {
    optionDetails: input.optionDetails,
    clientName: input.clientName,
    quantity: input.quantity,
    size: input.size,
    panelNumber: input.panelNumber,
    panelAddress: input.panelAddress,
    state: input.state,
    fixtureType: input.fixtureType,
    illuminationType: input.illuminationType,
    visualWidth: input.visualWidth,
    visualHeight: input.visualHeight,
    bleedWidth: input.bleedWidth,
    bleedHeight: input.bleedHeight,
    bleedTop: input.bleedTop,
    bleedBottom: input.bleedBottom,
    bleedLeft: input.bleedLeft,
    bleedRight: input.bleedRight,
    physicalWidth: input.physicalWidth,
    physicalHeight: input.physicalHeight,
    panelCensorships: input.panelCensorships,
    panelProhibitions: input.panelProhibitions,
    installCompanyName: input.installCompanyName,
    panelDirection: input.panelDirection,
    dimensions: input.dimensions,
    illuminated: input.illuminated,
    startDate: input.startDate,
    productionComments: input.productionComments,
    productionSpecs1: input.productionSpecs1,
    tssPlacementId: input.tssPlacementId,
  };
}

const QmsStaticPanel_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["panelNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Data on Qms Static panels (ie PrintOOH media).  Based on the emailed CSV for static media types.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"optionDetails","default":{"kind":"nothing"},"name":"optionDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"clientName","default":{"kind":"nothing"},"name":"clientName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"size","default":{"kind":"nothing"},"name":"size","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelNumber","default":{"kind":"nothing"},"name":"panelNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelAddress","default":{"kind":"nothing"},"name":"panelAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"fixtureType","default":{"kind":"nothing"},"name":"fixtureType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"illuminationType","default":{"kind":"nothing"},"name":"illuminationType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"visualWidth","default":{"kind":"nothing"},"name":"visualWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"visualHeight","default":{"kind":"nothing"},"name":"visualHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedWidth","default":{"kind":"nothing"},"name":"bleedWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedHeight","default":{"kind":"nothing"},"name":"bleedHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedTop","default":{"kind":"nothing"},"name":"bleedTop","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedBottom","default":{"kind":"nothing"},"name":"bleedBottom","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedLeft","default":{"kind":"nothing"},"name":"bleedLeft","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"bleedRight","default":{"kind":"nothing"},"name":"bleedRight","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"physicalWidth","default":{"kind":"nothing"},"name":"physicalWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"physicalHeight","default":{"kind":"nothing"},"name":"physicalHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"panelCensorships","default":{"kind":"nothing"},"name":"panelCensorships","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelProhibitions","default":{"kind":"nothing"},"name":"panelProhibitions","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"installCompanyName","default":{"kind":"nothing"},"name":"installCompanyName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelDirection","default":{"kind":"nothing"},"name":"panelDirection","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"dimensions","default":{"kind":"nothing"},"name":"dimensions","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"illuminated","default":{"kind":"nothing"},"name":"illuminated","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"productionComments","default":{"kind":"nothing"},"name":"productionComments","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"productionSpecs1","default":{"kind":"nothing"},"name":"productionSpecs1","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Mapping to TSS Placement table\n"}],"serializedName":"tssPlacementId","default":{"kind":"nothing"},"name":"tssPlacementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"QmsStaticPanel","version":{"kind":"nothing"}}};

export const snQmsStaticPanel: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsStaticPanel"};

export function texprQmsStaticPanel(): ADL.ATypeExpr<QmsStaticPanel> {
  return {value : {typeRef : {kind: "reference", value : snQmsStaticPanel}, parameters : []}};
}

/**
 * Row from the emailed CSV for digital media types:
 */
export interface QmsDigitalPanel {
  optionDetails: string;
  clientName: string;
  size: string;
  state: string;
  subareaName: string;
  panelNumber: string;
  panelAddress: string;
  bookingStartDate: string;
  bookingEndDate: string;
  materialType: string;
  visualWidth: number;
  visualHeight: number;
  pixelWidth: number;
  pixelHeight: number;
  installCompanyName: string;
  productionComments: string;
  panelCensorships: string;
  panelProhibitions: string;
  panelDirection: string;
  artworkDeadline: string;
  /**
   * Mapping to TSS Placement table
   */
  tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>;
}

export function makeQmsDigitalPanel(
  input: {
    optionDetails: string,
    clientName: string,
    size: string,
    state: string,
    subareaName: string,
    panelNumber: string,
    panelAddress: string,
    bookingStartDate: string,
    bookingEndDate: string,
    materialType: string,
    visualWidth: number,
    visualHeight: number,
    pixelWidth: number,
    pixelHeight: number,
    installCompanyName: string,
    productionComments: string,
    panelCensorships: string,
    panelProhibitions: string,
    panelDirection: string,
    artworkDeadline: string,
    tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>,
  }
): QmsDigitalPanel {
  return {
    optionDetails: input.optionDetails,
    clientName: input.clientName,
    size: input.size,
    state: input.state,
    subareaName: input.subareaName,
    panelNumber: input.panelNumber,
    panelAddress: input.panelAddress,
    bookingStartDate: input.bookingStartDate,
    bookingEndDate: input.bookingEndDate,
    materialType: input.materialType,
    visualWidth: input.visualWidth,
    visualHeight: input.visualHeight,
    pixelWidth: input.pixelWidth,
    pixelHeight: input.pixelHeight,
    installCompanyName: input.installCompanyName,
    productionComments: input.productionComments,
    panelCensorships: input.panelCensorships,
    panelProhibitions: input.panelProhibitions,
    panelDirection: input.panelDirection,
    artworkDeadline: input.artworkDeadline,
    tssPlacementId: input.tssPlacementId,
  };
}

const QmsDigitalPanel_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["panelNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Row from the emailed CSV for digital media types:\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"optionDetails","default":{"kind":"nothing"},"name":"optionDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"clientName","default":{"kind":"nothing"},"name":"clientName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"size","default":{"kind":"nothing"},"name":"size","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"subareaName","default":{"kind":"nothing"},"name":"subareaName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelNumber","default":{"kind":"nothing"},"name":"panelNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelAddress","default":{"kind":"nothing"},"name":"panelAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingStartDate","default":{"kind":"nothing"},"name":"bookingStartDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingEndDate","default":{"kind":"nothing"},"name":"bookingEndDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"materialType","default":{"kind":"nothing"},"name":"materialType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"visualWidth","default":{"kind":"nothing"},"name":"visualWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"visualHeight","default":{"kind":"nothing"},"name":"visualHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"pixelWidth","default":{"kind":"nothing"},"name":"pixelWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"pixelHeight","default":{"kind":"nothing"},"name":"pixelHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"installCompanyName","default":{"kind":"nothing"},"name":"installCompanyName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"productionComments","default":{"kind":"nothing"},"name":"productionComments","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelCensorships","default":{"kind":"nothing"},"name":"panelCensorships","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelProhibitions","default":{"kind":"nothing"},"name":"panelProhibitions","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"panelDirection","default":{"kind":"nothing"},"name":"panelDirection","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"artworkDeadline","default":{"kind":"nothing"},"name":"artworkDeadline","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Mapping to TSS Placement table\n"}],"serializedName":"tssPlacementId","default":{"kind":"nothing"},"name":"tssPlacementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"QmsDigitalPanel","version":{"kind":"nothing"}}};

export const snQmsDigitalPanel: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsDigitalPanel"};

export function texprQmsDigitalPanel(): ADL.ATypeExpr<QmsDigitalPanel> {
  return {value : {typeRef : {kind: "reference", value : snQmsDigitalPanel}, parameters : []}};
}

export interface QmsPanel_StaticPanel {
  kind: 'staticPanel';
  value: QmsStaticPanel;
}
export interface QmsPanel_DigitalPanel {
  kind: 'digitalPanel';
  value: QmsDigitalPanel;
}

export type QmsPanel = QmsPanel_StaticPanel | QmsPanel_DigitalPanel;

export interface QmsPanelOpts {
  staticPanel: QmsStaticPanel;
  digitalPanel: QmsDigitalPanel;
}

export function makeQmsPanel<K extends keyof QmsPanelOpts>(kind: K, value: QmsPanelOpts[K]) { return {kind, value}; }

const QmsPanel_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"staticPanel","default":{"kind":"nothing"},"name":"staticPanel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsStaticPanel"}},"parameters":[]}},{"annotations":[],"serializedName":"digitalPanel","default":{"kind":"nothing"},"name":"digitalPanel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsDigitalPanel"}},"parameters":[]}}]}},"name":"QmsPanel","version":{"kind":"nothing"}}};

export const snQmsPanel: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsPanel"};

export function texprQmsPanel(): ADL.ATypeExpr<QmsPanel> {
  return {value : {typeRef : {kind: "reference", value : snQmsPanel}, parameters : []}};
}

/**
 * Row from the emailed CSV for install company.
 */
export interface QmsInstallCompany {
  /**
   * Name of install company e.g. 'QMS Gold Coast'.
   */
  installCompany: string;
  /**
   * First address line e.g. 'Unit 2', 'Att: A.Dalgleish'
   */
  address1: string;
  /**
   * Second address line e.g. '9 Central Drive'
   */
  address2: string;
  /**
   * Third address line e.g. 'Slacks Creek'
   */
  address3: string;
  /**
   * Fourth address line e.g. 'QLD'
   */
  address4: string;
  /**
   * Fifth address line e.g. 'Australia'
   */
  address5: string;
  /**
   * Telephone e.g. '07 5593 8611'
   */
  telephone: string;
  /**
   * Email address e.g. 'ianrichards@qmsmedia.com'
   */
  emailAddress: common_strings.EmailAddress;
}

export function makeQmsInstallCompany(
  input: {
    installCompany: string,
    address1: string,
    address2: string,
    address3: string,
    address4: string,
    address5: string,
    telephone: string,
    emailAddress: common_strings.EmailAddress,
  }
): QmsInstallCompany {
  return {
    installCompany: input.installCompany,
    address1: input.address1,
    address2: input.address2,
    address3: input.address3,
    address4: input.address4,
    address5: input.address5,
    telephone: input.telephone,
    emailAddress: input.emailAddress,
  };
}

const QmsInstallCompany_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Row from the emailed CSV for install company.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of install company e.g. 'QMS Gold Coast'.\n"}],"serializedName":"installCompany","default":{"kind":"nothing"},"name":"installCompany","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"First address line e.g. 'Unit 2', 'Att: A.Dalgleish'\n"}],"serializedName":"address1","default":{"kind":"nothing"},"name":"address1","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Second address line e.g. '9 Central Drive'\n"}],"serializedName":"address2","default":{"kind":"nothing"},"name":"address2","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Third address line e.g. 'Slacks Creek'\n"}],"serializedName":"address3","default":{"kind":"nothing"},"name":"address3","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fourth address line e.g. 'QLD'\n"}],"serializedName":"address4","default":{"kind":"nothing"},"name":"address4","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fifth address line e.g. 'Australia'\n"}],"serializedName":"address5","default":{"kind":"nothing"},"name":"address5","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Telephone e.g. '07 5593 8611'\n"}],"serializedName":"telephone","default":{"kind":"nothing"},"name":"telephone","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address e.g. 'ianrichards@qmsmedia.com'\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}}]}},"name":"QmsInstallCompany","version":{"kind":"nothing"}}};

export const snQmsInstallCompany: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsInstallCompany"};

export function texprQmsInstallCompany(): ADL.ATypeExpr<QmsInstallCompany> {
  return {value : {typeRef : {kind: "reference", value : snQmsInstallCompany}, parameters : []}};
}

/**
 * Stores the relationship between a QMS campaign and a TSS campaign.
 */
export interface QmsCampaign {
  /**
   * TSS Campaign ID
   */
  tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
  /**
   * Campaign code claim from the QMS API
   */
  qmsCampaignCode: string;
  /**
   * Name of client from the QMS API
   */
  qmsClient: string;
  extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef;
}

export function makeQmsCampaign(
  input: {
    tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
    qmsCampaignCode: string,
    qmsClient: string,
    extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef,
  }
): QmsCampaign {
  return {
    tssCampaignId: input.tssCampaignId,
    qmsCampaignCode: input.qmsCampaignCode,
    qmsClient: input.qmsClient,
    extCampaignRef: input.extCampaignRef,
  };
}

const QmsCampaign_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["qmsCampaignCode"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Stores the relationship between a QMS campaign and a TSS campaign.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TSS Campaign ID\n"}],"serializedName":"tssCampaignId","default":{"kind":"nothing"},"name":"tssCampaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign code claim from the QMS API\n"}],"serializedName":"qmsCampaignCode","default":{"kind":"nothing"},"name":"qmsCampaignCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of client from the QMS API\n"}],"serializedName":"qmsClient","default":{"kind":"nothing"},"name":"qmsClient","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"extCampaignRef","default":{"kind":"nothing"},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}}]}},"name":"QmsCampaign","version":{"kind":"nothing"}}};

export const snQmsCampaign: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsCampaign"};

export function texprQmsCampaign(): ADL.ATypeExpr<QmsCampaign> {
  return {value : {typeRef : {kind: "reference", value : snQmsCampaign}, parameters : []}};
}

export interface QmsBooking {
  /**
   * TSS Campaign ID
   */
  tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
  /**
   * TSS Booking Ref
   * The value is constructed as a hash from matching values in QmsCampaignBooking
   */
  tssBookingRef: kachemedia_specsheet_db.BookingRef;
  /**
   * Foreign key to TSS placement table where we've mapped
   * the data obtained from the QMS spreadsheets sent over
   * weekly containing the specs for all their placements/panels.
   */
  tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>;
  /**
   * The value for Booking.extCampaignRef (value derived from qms campaign code + client)
   */
  extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef;
  /**
   * The source of the booking - qms or ooh
   */
  source: BookingSource;
}

export function makeQmsBooking(
  input: {
    tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
    tssBookingRef: kachemedia_specsheet_db.BookingRef,
    tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>,
    extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef,
    source?: BookingSource,
  }
): QmsBooking {
  return {
    tssCampaignId: input.tssCampaignId,
    tssBookingRef: input.tssBookingRef,
    tssPlacementId: input.tssPlacementId,
    extCampaignRef: input.extCampaignRef,
    source: input.source === undefined ? 0 : input.source,
  };
}

const QmsBooking_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["tss_booking_ref"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TSS Campaign ID\n"}],"serializedName":"tssCampaignId","default":{"kind":"nothing"},"name":"tssCampaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TSS Booking Ref\nThe value is constructed as a hash from matching values in QmsCampaignBooking\n"}],"serializedName":"tssBookingRef","default":{"kind":"nothing"},"name":"tssBookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Foreign key to TSS placement table where we've mapped\nthe data obtained from the QMS spreadsheets sent over\nweekly containing the specs for all their placements/panels.\n"}],"serializedName":"tssPlacementId","default":{"kind":"nothing"},"name":"tssPlacementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The value for Booking.extCampaignRef (value derived from qms campaign code + client)\n"}],"serializedName":"extCampaignRef","default":{"kind":"nothing"},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The source of the booking - qms or ooh\n"}],"serializedName":"source","default":{"kind":"just","value":"qms"},"name":"source","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"BookingSource"}},"parameters":[]}}]}},"name":"QmsBooking","version":{"kind":"nothing"}}};

export const snQmsBooking: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsBooking"};

export function texprQmsBooking(): ADL.ATypeExpr<QmsBooking> {
  return {value : {typeRef : {kind: "reference", value : snQmsBooking}, parameters : []}};
}

export enum BookingSource {
  qms,
  ooh,
}

const BookingSource_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"qms","default":{"kind":"nothing"},"name":"qms","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ooh","default":{"kind":"nothing"},"name":"ooh","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BookingSource","version":{"kind":"nothing"}}};

export const snBookingSource: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"BookingSource"};

export function texprBookingSource(): ADL.ATypeExpr<BookingSource> {
  return {value : {typeRef : {kind: "reference", value : snBookingSource}, parameters : []}};
}

export interface QmsTablesMap {
  qmsCampaigns: sys_types.Map<common_db.DbKey<QmsCampaign>, QmsCampaign>;
  qmsBookings: sys_types.Map<common_db.DbKey<QmsBooking>, QmsBooking>;
}

export function makeQmsTablesMap(
  input: {
    qmsCampaigns: sys_types.Map<common_db.DbKey<QmsCampaign>, QmsCampaign>,
    qmsBookings: sys_types.Map<common_db.DbKey<QmsBooking>, QmsBooking>,
  }
): QmsTablesMap {
  return {
    qmsCampaigns: input.qmsCampaigns,
    qmsBookings: input.qmsBookings,
  };
}

const QmsTablesMap_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.qms","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"qmsCampaigns","default":{"kind":"nothing"},"name":"qmsCampaigns","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsCampaign"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsCampaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"qmsBookings","default":{"kind":"nothing"},"name":"qmsBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsBooking"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsBooking"}},"parameters":[]}]}}]}},"name":"QmsTablesMap","version":{"kind":"nothing"}}};

export const snQmsTablesMap: ADL.ScopedName = {moduleName:"kachemedia.specsheet.qms", name:"QmsTablesMap"};

export function texprQmsTablesMap(): ADL.ATypeExpr<QmsTablesMap> {
  return {value : {typeRef : {kind: "reference", value : snQmsTablesMap}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.qms.QmsCampaignBooking" : QmsCampaignBooking_AST,
  "kachemedia.specsheet.qms.QmsStaticPanel" : QmsStaticPanel_AST,
  "kachemedia.specsheet.qms.QmsDigitalPanel" : QmsDigitalPanel_AST,
  "kachemedia.specsheet.qms.QmsPanel" : QmsPanel_AST,
  "kachemedia.specsheet.qms.QmsInstallCompany" : QmsInstallCompany_AST,
  "kachemedia.specsheet.qms.QmsCampaign" : QmsCampaign_AST,
  "kachemedia.specsheet.qms.QmsBooking" : QmsBooking_AST,
  "kachemedia.specsheet.qms.BookingSource" : BookingSource_AST,
  "kachemedia.specsheet.qms.QmsTablesMap" : QmsTablesMap_AST
};
